import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import VueMoment from 'vue-moment'
import lc from 'locale-code'
import { localize } from 'vee-validate'
import en from 'vee-validate/dist/locale/en.json'
import de from 'vee-validate/dist/locale/de.json'
import { http } from '../api/http'
import store from 'customerPath/store'

Vue.use(VueI18n)
Vue.use(VueMoment, { moment })

localize({
  en,
  de,
})

const numberFormats = {
  'de-DE': {
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
    },
    percent: {
      style: 'percent',
      minimumFractionDigits: 2,
    },
  },
}

// load vee-validate locale and change ex. de_DE to de-DE
function loadLocale(code) {
  const locale = lc.getLanguageCode(code)
  localize(locale)
}

export const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'de-DE',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de-DE',
  // messages: loadLocaleMessages(),
  formatedLocale: process.env.VUE_APP_I18N_FORMATED_LOCALE || 'de_DE',
  numberFormats,
})

const loadedLanguages = [] // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang
  i18n.formatedLocale = lang.replace(/-/g, '_')
  moment.locale(lang.split('-')[0])
  // axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync(lang, isLanguageChanged = false) {
  const locale = lang.replace(/_/g, '-')
  store.dispatch('translations/setPendingTranslations')
  // If the same language
  // If the language was already loaded
  if (!isLanguageChanged && (
    (
      i18n.locale === locale && loadedLanguages.includes(locale)
    ) || loadedLanguages.includes(locale)
  )) {
    loadLocale(locale)
    store.dispatch('translations/setPendingTranslations')
    return Promise.resolve(setI18nLanguage(locale))
  }

  return new Promise(resolve => {
    http.get(`languages/${lang}`).then(({ data }) => {
      i18n.setLocaleMessage(locale, data)
      loadedLanguages.push(locale)
      loadLocale(locale)
      resolve(setI18nLanguage(locale))
      store.dispatch('translations/setPendingTranslations')
    })
  })
}
